export default {
	darkerGray: '#151516',
	darkGray: '#1A1A1F',
	gray: 'rgb(28, 28, 30)',
	medGray: '#54545A',
	white: '#ffffff',
	purple: '#362A68',
	green: '#019C00',
	paleGreen: '#A6FF79',
	red: '#FF443A',
	textGray: '#878793',
	textLight: '#B2B2BF',
	popoverPackground: '#151516',
	buttonGray: '#1A1A1F',
	nearWhite: '#FCFCFC',
	textBlue: '#0023F5',
	textGreen: '#A2FA4E',
	textYellow: '#FFFC54',
	eggplant: '#522967',
	eggplantLight: '#763A95',
	initialBackgroundColor: '#151515',
	blGrayscale1100: '#121114',
};
